import { actionTypes } from 'actions/account/actionTypes';
const initState = {
  profile: {},
  loadingGetProfile: false,
  loadingChangePass: false,
  loadingSetupStripe: false,
  loadingSubscription: false,
  errorChangePass: '',
  errorChangeProfile: '',
  loadingSendSupportEmail: false,
};

export default (state = initState, action: any) => {
  const { payload, type } = action;
  switch (type) {
    case actionTypes.SEND_SUPPORT_EMAIL: {
      return {
        ...state,
        loadingSendSupportEmail: true
      };
    }
    case actionTypes.SEND_SUPPORT_EMAIL_SUCCESS: {
      return {
        ...state,
        loadingSendSupportEmail: false
      };
    }
    case actionTypes.SEND_SUPPORT_EMAIL_FAIL: {
      return {
        ...state,
        loadingSendSupportEmail: false,
      };
    }

    case actionTypes.GET_PROFILE: {
      return {
        ...state,
        loadingGetProfile: true
      };
    }
    case actionTypes.GET_PROFILE_FAIL: {
      return {
        ...state,
        loadingGetProfile: false
      };
    }
    case actionTypes.GET_PROFILE_SUCCESS: {
      return {
        ...state,
        profile: payload,
        loadingGetProfile: false,
      };
    }
    case actionTypes.UPDATE_PROFILE_SUCCESS: {
      return {
        ...state,
        profile: payload,
      };
    }
    case actionTypes.UPDATE_PROFILE_FAIL: {
      return {
        ...state,
        errorChangeProfile: payload,
      };
    }
    case actionTypes.CLEAR_ERROR_CHANGE_PROFILE: {
      return {
        ...state,
        errorChangeProfile: '',
      };
    }
    case actionTypes.CHANGE_PASSWORD: {
      return {
        ...state,
        loadingChangePass: true,
      };
    }
    case actionTypes.CHANGE_PASSWORD_FAIL:
    case actionTypes.CHANGE_PASSWORD_SUCCESS: {
      return {
        ...state,
        loadingChangePass: false,
      };
    }
    case actionTypes.SETUP_STRIPE: {
      return {
        ...state,
        loadingSetupStripe: true,
      };
    }
    case actionTypes.SETUP_STRIPE_FAIL:
    case actionTypes.SETUP_STRIPE_SUCCESS: {
      return {
        ...state,
        loadingSetupStripe: false,
      };
    }

    case actionTypes.SUBSCRIPTION_STRIPE: {
      return {
        ...state,
        loadingSubscription: true,
      };
    }
    case actionTypes.SUBSCRIPTION_STRIPE_FAIL:
    case actionTypes.SUBSCRIPTION_STRIPE_SUCCESS: {
      return {
        ...state,
        loadingSubscription: false,
      };
    }

    case actionTypes.CANCEL_SUBSCRIPTION: {
      return {
        ...state,
        loadingSubscription: true,
      };
    }
    case actionTypes.CANCEL_SUBSCRIPTION_FAIL:
    case actionTypes.CANCEL_SUBSCRIPTION_SUCCESS: {
      return {
        ...state,
        loadingSubscription: false,
      };
    }
    default:
      return state;
  }
};
